export function auth({ next, store }) {
  if (store.state.user === null) {
    return next("/login");
  } else {
    return next();
  }
}
